import download from './download';
import remove from './remove';
import add from './add';

export default [remove, download, add];
